import {
  FleetVehicleDamageEditFormValues,
  FleetVehicleDamageSearchFormValues,
} from "./types";

export const initialFleetVehicleDamageSearchForm: FleetVehicleDamageSearchFormValues =
  {
    search: "",
    vehicleDamageStatusId: "",
    vehicleManufacturerId: null,
    vehicleModelId: null,
    vehicleTypeId: null,
    damageDateFrom: null,
    damageDateTo: null,
  };

export const initialFleetVehicleDamageEditForm: FleetVehicleDamageEditFormValues =
  {
    id: "",
    vehicleId: "",
    name: "",
    description: "",
    damageDate: null,
    pins: [],
    photoUploads: [],
    documentUploads: [],
  };
